// src/core/factory.js
import defaultConfig from "../../config/default.config";

export class ServiceFactory {
  constructor(config = {}) {
    this.config = { ...defaultConfig, ...config };
    this.services = new Map();
  }

  // 注册服务适配器
  registerService(type, provider, adapter) {
    const key = `${type}-${provider}`;
    this.services.set(key, adapter);
    console.log(`Service registered: ${key}`);
  }

  // 获取服务实例
  getService(type) {
    const provider = this.config.providers[type];
    const key = `${type}-${provider}`;

    if (!this.services.has(key)) {
      throw new Error(`Service ${key} not registered`);
    }

    console.log(`Service retrieved: ${key}`);
    return this.services.get(key);
  }
}

export const serviceFactory = new ServiceFactory();
